<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="5">
        <v-card class="pa-4 text-center">
          <v-card-title class="justify-center">
            Your subscription has expired
          </v-card-title>
          <v-card-text>
            Your DynamicOdds subscription is no longer active, so live pricing
            data is unavailable. Renew your subscription to get straight back in
            &mdash; your account and settings are unchanged.
          </v-card-text>
          <v-card-actions class="justify-center flex-column">
            <v-btn color="success" large @click="renew">
              Renew subscription
            </v-btn>
            <v-btn text small class="mt-3" @click="checkAgain">
              I've renewed &mdash; check again
            </v-btn>
            <v-btn text small class="mt-1" @click="logout">
              Log out
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { openSubscriptionWidget } from '../services/userAccount'

export default {
  name: 'SubscriptionExpired',
  methods: {
    // Opens the embedded payment widget. On success, boot the app fresh so
    // the whole auth + token exchange flow re-runs against the new
    // subscription (denials are negative-cached server-side for up to a
    // minute, so the widget's success callback may land slightly before
    // access is restored — the exchange retry handles that).
    renew () {
      openSubscriptionWidget({
        onSuccess: () => { window.location = '/' },
        onCancel: () => {},
        cancelText: 'Cancel'
      })
    },
    // Full reload rather than a router push: the app's token state and apollo
    // connections were built for an unsubscribed session, and a fresh boot
    // re-runs the whole auth + exchange flow against the renewed subscription.
    checkAgain () {
      window.location = '/'
    },
    async logout () {
      await this.$store.dispatch('account/logout')
      this.$router.push('/login')
    }
  }
}
</script>
